import {useMutation} from '@tanstack/react-query';
import queryClient from '@/utils/reactQueryClient';
import assetUpdaters from '@/api/updaters/content-studio/asset';
import {CONTENT_LAB, ASSETS} from '../../consts';

function useRenameAsset({
  onMutate,
  onError,
  onSuccess,
}: {
  onSuccess?: (data: unknown) => void;
  onMutate?: (data: {assetId: string; name: string}) => void;
  onError?: (error: unknown, variables: unknown, context: unknown) => void;
} = {}) {
  return useMutation({
    mutationFn: ({assetId, name}: {assetId: string; name: string}) => {
      return assetUpdaters.renameAsset(assetId, name);
    },
    onMutate,
    onError,
    onSuccess:
      onSuccess ||
      (() => {
        queryClient.invalidateQueries({queryKey: [CONTENT_LAB, ASSETS]});
      }),
  });
}

export default useRenameAsset;
